import { makeStyles } from '@material-ui/core';

export const stylesTabRoles = makeStyles({
  paper: { width: '100%', height: '100%', padding: '11px 30px' },
});
